import React from "react";
import {
	Accordion,
	Header,
	List,
	Menu,
	Message,
	Table,
} from "semantic-ui-react";
import { parseDate } from "utilities/date";
import { calculateTotalStockAmount } from "utilities/stocks";

const InventoryAccordion = ({ inventories }) => {
	return (
		<List>
			{!inventories.length ? (
				<Message attached="bottom" content="Inventory is empty." />
			) : (
				<Accordion
					className="inventoryAccordion"
					as={List.Item}
					exclusive
					styled
					fluid
					defaultActiveIndex={0}
					panels={inventories.map((item) => ({
						key: item._id,
						title: {
							content: (
								<Header as="h4">
									{`${item.name} - ${item.localName}`}
								</Header>
							),
						},
						content: {
							content: (
								<>
									<Table celled style={{ margin: 0 }}>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell>
													S.N.
												</Table.HeaderCell>
												<Table.HeaderCell>
													Supplier
												</Table.HeaderCell>
												<Table.HeaderCell>
													Purchased Date
												</Table.HeaderCell>
												<Table.HeaderCell>
													Invoice No.
												</Table.HeaderCell>
												<Table.HeaderCell>
													Quantity
												</Table.HeaderCell>
												<Table.HeaderCell>
													Rate
												</Table.HeaderCell>
											</Table.Row>
										</Table.Header>

										<Table.Body>
											{item.stocks.map((st, i) => (
												<Table.Row>
													<Table.Cell>
														{i + 1}
													</Table.Cell>
													<Table.Cell>
														{st.supplier?.name ??
															"Not specified"}
													</Table.Cell>
													<Table.Cell>
														{parseDate(st.addedOn)}
													</Table.Cell>
													<Table.Cell>
														{st.invoiceNo}
													</Table.Cell>
													<Table.Cell>
														{st.quantity}
													</Table.Cell>
													<Table.Cell>
														Rs.{st.rate}
													</Table.Cell>
												</Table.Row>
											))}
										</Table.Body>
									</Table>
									<Menu
										borderless
										style={{
											boxShadow: "none",
											margin: 0,
											borderTop: 0,
										}}
									>
										<Menu.Menu position="right">
											<Menu.Item>
												Total Stock Value:
											</Menu.Item>
											<Menu.Item>
												NPR{" "}
												{calculateTotalStockAmount(
													item.stocks
												)}
												/-
											</Menu.Item>
										</Menu.Menu>
									</Menu>
								</>
							),
						},
					}))}
				/>
			)}
		</List>
	);
};

export default InventoryAccordion;
